import { Modal } from 'rsuite'
import { BsAsterisk } from 'react-icons/bs'
import useTranslation from '../../hooks/useTranslation'
import Image from 'next/image'

const ShowVinInfoModal = ({ show, onHide }) => {
  const t = useTranslation()
  return (
    <Modal open={show} onClose={onHide} size="xs">
      <Modal.Header>
        <Modal.Title>&nbsp;</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="flex-l mb-20">
          <BsAsterisk color="black" className="mr-20" style={{ fontSize: '1.3em' }} />
          <h5>{t('vin_hint_what_is_vin')}</h5>
        </div>
        <p>
          {t('vin_hint_what_is_vin_explained')}.<br />
          <br />
          {t('vin_hint_example_of_vin')}:
        </p>
        <div className="flex-l">
          <div
            style={{
              border: '1px solid black',
              marginTop: '10px',
              padding: '10px'
            }}
          >
            <h3>1HGBH41JXMN10186</h3>
          </div>
        </div>
        <div className="flex-l mt-30 mb-20">
          <BsAsterisk color="black" className="mr-20" style={{ fontSize: '1.3em' }} />
          <h5>{t('vin_hint_where_to_find')}</h5>
        </div>
        <div className="flex-l">
          <div style={{ width: 180 }}>{t('vin_hint_where_to_find_explained')}.</div>
          <div style={{ position: 'relative', aspectRatio: '16/9', width: '40%' }}>
            <Image
              src="/images/group113.png"
              alt="group113.png"
              className="center"
              fill
              style={{ objectFit: 'contain' }}
            />
          </div>
        </div>
        <div className="flex-l mt-30 mb-20">
          <BsAsterisk color="black" className="mr-20" style={{ fontSize: '1.3em' }} />
          <h5>{t('vin_hint_where_on_vehicle')}</h5>
        </div>
        <div className="flex-c mt-20 mb-20">
          <div style={{ position: 'relative', aspectRatio: '16/9', width: '100%' }}>
            <Image
              src="/images/group112.png"
              alt="group112.png"
              className="center"
              fill
              style={{ objectFit: 'contain' }}
            />
          </div>
        </div>
        <p>
          <ol>
            <li>{t('vin_hint_where_on_vehicle_explained_1')}.</li>
            <li>{t('vin_hint_where_on_vehicle_explained_2')}.</li>
            <li>{t('vin_hint_where_on_vehicle_explained_3')}.</li>
            <li>{t('vin_hint_where_on_vehicle_explained_4')}.</li>
          </ol>
        </p>
      </Modal.Body>
    </Modal>
  )
}

export default ShowVinInfoModal
